import { getItem } from "@/utils/storage.js";
import axios from "axios";

const baseUrl = `${process.env.VUE_APP_BASE_URL}`;
// Declared to match investor-app.
const userUrl = `${baseUrl}/user`;
const organisationUrl = `${baseUrl}/organisation`;
const transactionUrl = `${baseUrl}/transaction`;
const tokenUrl = `${baseUrl}/tokens`;
const orgsApiUrl = `${baseUrl}/organisations`;

export default {
	getHeader: () => {
		let headers = {
			Authorization: "Bearer " + getItem("org_token"),
		};
		return headers;
	},

	loginOrganisation(data) {
		return axios.post(`${baseUrl}/company/login`, data);
	},

	createOrganisation(data) {
		return axios.post(`${organisationUrl}`, data);
	},

	getOrganisationProfile(id) {
		return axios.get(`${organisationUrl}/auth/${id}`, {
			headers: this.getHeader(),
		});
	},

	getOrganisationOverview() {
		return axios.get(`${organisationUrl}/overview`, {
			headers: this.getHeader(),
		});
	},

	updateOrganisationDetails(data) {
		return axios.patch(`${organisationUrl}`, data, {
			headers: this.getHeader(),
		});
	},

	sendToken(data) {
		return axios.patch(`${organisationUrl}/send-token`, data, {
			headers: this.getHeader(),
		});
	},

	verifyOrganisation(data) {
		return axios.patch(`${organisationUrl}/verify`, data, {
			headers: this.getHeader(),
		});
	},

	submitDocument(data) {
		const type = data.documents[0].type;
		return axios.post(`${baseUrl}/kyc/documents/${type}`, data, {
			headers: this.getHeader(),
		});
	},
	deleteFounder({ id, asset }) {
		return axios({
			url: `${baseUrl}/founders/${id}`,
			method: "DELETE",
			data: { asset },
			headers: this.getHeader(),
		});
	},

	uploadSelfie(selfie) {
		return axios({
			url: "kyc/selfie",
			data: selfie,
			method: "POST",
			headers: this.getHeader(),
		});
	},

	getWalletTransaction(query) {
		return axios.get(`${transactionUrl}/organisation`, {
			params: {
				page: query.page,
				// type: query.type,
				limit: query.limit,
			},
			headers: this.getHeader(),
		});
	},

	getBankDetails() {
		return axios.get(`${baseUrl}/bank`, {
			headers: this.getHeader(),
		});
	},

	getWalletBalance() {
		return axios.get(`${baseUrl}/token/currency-balance`, {
			headers: this.getHeader(),
		});
	},

	getTransactions(payload) {
		return axios.get(`${transactionUrl}/organisation`, {
			params: {
				page: payload.page,
				limit: payload.limit,
				type: payload.type,
			},
			headers: this.getHeader(),
		});
	},

	getUserTransactions(payload) {
		return axios.get(`${transactionUrl}/user`, {
			params: {
				page: payload.page,
				limit: payload.limit,
				type: payload.type,
				tokenId: payload.tokenId,
			},
			headers: this.getHeader(),
		});
	},

	getExchangeRate(query) {
		return axios.get(`${baseUrl}/payments/fx-rate`, {
			params: {
				from: query.from,
				to: query.to,
			},
			headers: this.getHeader(),
		});
	},

	createWithdrawalRequest(data) {
		return axios.post(`${baseUrl}/withdrawal-requests`, data, {
			headers: this.getHeader(),
		});
	},

	fetchBankAccounts() {
		return axios({
			url: `${baseUrl}/bank`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	resetPasswordLink(data) {
		return axios.post(`${organisationUrl}/initiate-password-reset`, data, {
			headers: this.getHeader(),
		});
	},

	resetPassword(data) {
		return axios.patch(`${baseUrl}/organisation/reset-pass`, data, {
			headers: this.getHeader(),
		});
	},

	resetPin(data) {
		return axios.post(`${baseUrl}/organisation/reset-pin`, data, {
			headers: this.getHeader(),
		});
	},

	createPin(data) {
		return axios.post(`${baseUrl}/organisation/create-pin`, data, {
			headers: this.getHeader(),
		});
	},

	verifyPin(pin) {
		return axios({
			url: `${organisationUrl}/verify-pin`,
			data: pin,
			method: "POST",
			headers: this.getHeader(),
		});
	},

	getNotifications(query) {
		return axios.get(`${baseUrl}/notifications`, {
			params: {
				page: query.page,
				limit: query.limit,
			},
			headers: this.getHeader(),
		});
	},

	getTotalUnreadNotifications() {
		return axios.get(`${baseUrl}/notifications/total-unread`, {
			headers: this.getHeader(),
		});
	},

	markAllNotificationsRead() {
		return axios({
			url: `${baseUrl}/notifications/read`,
			method: "PUT",
			data: {},
			headers: this.getHeader(),
		});
	},

	deleteBank(bank) {
		return axios({
			url: `${baseUrl}/bank/${bank}`,
			method: "DELETE",
			headers: this.getHeader(),
		});
	},
	getVestingSchedule() {
		return axios({
			url: `${organisationUrl}/vesting-schedule?type=EMPLOYEE_STOCK_OPTIONS`,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	createEsopToken(esopToken) {
		return axios({
			url: `${baseUrl}/esop-token`,
			method: "POST",
			headers: this.getHeader(),
			data: esopToken,
		});
	},
	updateEsopToken(esopToken) {
		return axios({
			url: `${baseUrl}/esop-token`,
			method: "PATCH",
			headers: this.getHeader(),
			data: esopToken,
		});
	},
	getEsopToken() {
		return axios({
			url: `${baseUrl}/esop-token`,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	createVestingSchedule(payload) {
		return axios({
			url: `${organisationUrl}/vesting-schedule`,
			method: "POST",
			headers: this.getHeader(),
			data: payload,
		});
	},
	updateVestingSchedule(payload) {
		return axios({
			url: `${organisationUrl}/vesting-schedule`,
			method: "PATCH",
			headers: this.getHeader(),
			data: payload,
		});
	},
	getEsoOverviewData(query) {
		return axios.get(`${organisationUrl}/esop-overview`, {
			params: {
				employee_type: query.employee_type,
			},
			headers: this.getHeader(),
		});
	},
	InviteEmployee(payload) {
		return axios({
			url: `${organisationUrl}/employee-invite`,
			method: "POST",
			data: payload,
			headers: this.getHeader(),
		});
	},
	updateEmployeeInvite({ payload, id }) {
		return axios({
			url: `${organisationUrl}/employee-invite/${id}`,
			method: "PATCH",
			data: payload,
			headers: this.getHeader(),
		});
	},
	getEmployeeInvites(query) {
		return axios({
			url: `${baseUrl}/employee-invites`,
			params: query,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	getEmployeeInvite(id) {
		return axios({
			url: `${organisationUrl}/employee-invite/${id}`,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	cancelInvite(id) {
		return axios({
			url: `${organisationUrl}/cancel-employee-invite/${id}`,
			method: "DELETE",
			headers: this.getHeader(),
		});
	},
	terminateEmployeeEsop(id) {
		return axios({
			url: `${baseUrl}/employee/${id}/terminate`,
			method: "PATCH",
			headers: this.getHeader(),
		});
	},

	getOrganisationPlan() {
		return axios.get(`${baseUrl}/plans/organisation`, {
			headers: this.getHeader(),
		});
	},

	getPlans() {
		return axios.get(`${baseUrl}/plans/flutterwave`, {
			headers: this.getHeader(),
		});
	},
	fetchSubscriptions() {
		return axios({
			url: `${organisationUrl}/subscription-fees`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	updateSubscription(subscription) {
		return axios({
			url: `${organisationUrl}/subscription-fees`,
			method: "PATCH",
			data: subscription,
			headers: this.getHeader(),
		});
	},

	getCustomers(params) {
		return axios({
			url: `${baseUrl}/api/customers`,
			params,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	getTotalTransactionVolume() {
		return axios({
			url: `${baseUrl}/api/transactions/volume`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	toggleEnvironment(value) {
		return axios({
			url: `${orgsApiUrl}/toggle-environment`,
			method: "POST",
			data: value,
			headers: this.getHeader(),
		});
	},
	getApikey() {
		return axios({
			url: `${orgsApiUrl}/api-keys`,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	generateApikey(live) {
		return axios({
			url: `${orgsApiUrl}/api-keys`,
			method: "POST",
			headers: this.getHeader(),
			data: {
				live
			},
		});
	},
	getApiWebHook() {
		return axios({
			url: `${orgsApiUrl}/webhooks`,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	addWebHook(payload, live) {
		return axios({
			url: `${orgsApiUrl}/webhooks`,
			method: "POST",
			data: {
				...payload,
				live
			},
			headers: this.getHeader(),
		});
	},
	updateWebhook(payload, live) {
		return axios({
			url: `${orgsApiUrl}/webhooks`,
			method: "PATCH",
			data: {
				...payload,
				live
			},
			headers: this.getHeader(),
		});
	},
	searchCustomers(name) {
		return axios({
			url: `${baseUrl}/api/customers/search?name=${name}`,
			headers: this.getHeader(),
			method: "GET",
		});
	},
	getCustomerTransactions(params) {
		return axios({
			url: `${baseUrl}/api/customers/transactions`,
			params,
			headers: this.getHeader(),
			method: "GET",
		});
	},
	getApiTransactions(params) {
		return axios({
			url: `${baseUrl}/transaction/organisation`,
			params,
			headers: this.getHeader(),
			method: "GET",
		});
	},
	subscribeToFeature(payload) {
		return axios({
			url: `${baseUrl}/organisation/product-subscription`,
			data: { ...payload, live: process.env.VUE_APP_LIVE_STATUS },
			headers: this.getHeader(),
			method: "POST",
		});
	},

	getOrganisationAsset() {
		return axios.get(`${organisationUrl}/token`, {
			headers: this.getHeader(),
		});
	},

	getAsset(id) {
		return axios.get(`${baseUrl}/asset/${id}`, {
			headers: this.getHeader(),
		});
	},

	createAsset(data) {
		return axios.post(`${baseUrl}/asset`, data, {
			headers: this.getHeader(),
		});
	},

	updateAsset(payload) {
		return axios.patch(`${baseUrl}/asset/${payload.id}`, payload.data, {
			headers: this.getHeader(),
		});
	},

	createTokenRequest(data) {
		return axios.post(`${baseUrl}/token-requests`, data, {
			headers: this.getHeader(),
		});
	},

	updateTokenRequest(data) {
		return axios({
			url: `${baseUrl}/token-requests/${data.id}`,
			data: data.deal || data.payload,

			headers: this.getHeader(),
			method: "PATCH",
		});
	},

	getEsopOrder(id) {
		return axios.get(
			`${baseUrl}/orders/token/${id}?esop=${true}&status=Active`,
			{
				headers: this.getHeader(),
			}
		);
	},

	// verifyPin(data) {
	//     return axios.post(`${organisationUrl}/verify-pin`, data, {
	//         headers: this.getHeader(),
	//     });
	// },

	buyEsop(data) {
		return axios.post(
			`${baseUrl}/token/${data.id}/buy`,
			{ amount: data.amount, price: data.price },
			{
				headers: this.getHeader(),
			}
		);
	},

	searchAsset(name) {
		return axios({
			url: `${organisationUrl}/assets/search?name=${name}`,
			headers: this.getHeader(),
			method: "GET",
		});
	},
	getFeatures() {
		return axios({
			url: `${baseUrl}/products`,
			headers: this.getHeader(),
			method: "GET",
		});
	},
	// getTokens() {
	//   return axios({
	//     url: `${baseUrl}/token/organisation`,
	//     headers: this.getHeader(),
	//     method: "GET",
	//   });
	// },
	getOrganisationUpdate(query) {
		return axios.get(`${baseUrl}/organisation-update/${query.id}`, {
			// params: {
			//   page: query.page,
			//   limit: query.limit,
			// },
			headers: this.getHeader(),
		});
	},

	submitOrganisationUpdates(payload) {
		return axios.post(`${baseUrl}/organisation-update`, payload.data, {
			headers: this.getHeader(),
		});
	},
	getTransactionFees() {
		return axios.get(`${baseUrl}/transaction/fee`, {
			headers: this.getHeader(),
		});
	},
	requestToken(token) {
		return axios.post(`${baseUrl}/token-requests`, token, {
			headers: this.getHeader(),
		});
	},
	getTokenRequests() {
		return axios.get(`${baseUrl}/token-requests`, {
			headers: this.getHeader(),
		});
	},
	getTokenRequest(id) {
		return axios.get(`${baseUrl}/token-requests/${id}`, {
			headers: this.getHeader(),
		});
	},
	getDealMembers(id) {
		return axios.get(`${baseUrl}/deal/${id}/members`, {
			headers: this.getHeader(),
		});
	},
	getTokenTransactions(query) {
		//changed here
		const id = query.id;
		delete query.id;
		const params = query;
		return axios.get(`${transactionUrl}/token/${id}`, {
			params,
			headers: this.getHeader(),
		});
	},
	fetchDealInvestors(id) {
		return axios({
			url: `${baseUrl}/token/${id}/investors`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	fetchMemberByName(query) {
		return axios.get(`${organisationUrl}/member/search?param=${query}`, {
			headers: this.getHeader(),
		});
	},

	inviteMember(obj) {
		return axios({
			url: `${baseUrl}/deal/${obj.id}/invite-members`,
			method: "POST",
			data: {
				deal_access: "Private",
				members: obj.members,
				mail_base_url: obj.url,
			},
			headers: this.getHeader(),
		});
	},

	deactivateMember(memberId) {
		return axios({
			url: `${organisationUrl}/members/${memberId}/deactivate`,
			method: "PATCH",
			headers: this.getHeader(),
		});
	},

	activateMember(memberId) {
		return axios({
			url: `${organisationUrl}/members/${memberId}/activate`,
			method: "PATCH",
			headers: this.getHeader(),
		});
	},

	pendingInvite(param) {
		return axios.post(
			`${baseUrl}/pending-invite/${param.id}/${param.action}`,
			{},
			{
				headers: this.getHeader(),
			}
		);
	},

	removeMember(memberId) {
		return axios({
			url: `${baseUrl}/deal-member/${memberId}/remove-member`,
			method: "DELETE",
			headers: this.getHeader(),
		});
	},

	requestRefund(data) {
		return axios.post(`${baseUrl}/payments/refund`, data, {
			headers: this.getHeader(),
		});
	},

	getOrderBooks(query) {
		return axios.get(`${baseUrl}/order/user`, {
			params: {
				tokenId: query.id,
				// type: query.type,
				page: query.page,
				limit: query.limit,
				status: query.status,
			},
			headers: this.getHeader(),
		});
	},

	getTokenOrders(query) {
		return axios.get(`${baseUrl}/orders/token/${query.id}`, {
			params: {
				type: query.data && query.data.type,
				page: query.data && query.data.page,
				limit: query.data && query.data.limit,
				status: query.data && query.data.status,
			},
			headers: this.getHeader(),
		});
	},

	getTokenByName(params) {
		return axios({
			url: `${baseUrl}/token/search`,
			headers: this.getHeader(),
			params,
		});
	},

	cancelOrder(id) {
		return axios.post(
			`${baseUrl}/order/cancel/${id}`,
			{},
			{
				headers: this.getHeader(),
			}
		);
	},
	fetchSpvRequests(params) {
		return axios({
			url: `${baseUrl}/spv`,
			params,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	fetchSpvs(params) {
		return axios({
			url: `${baseUrl}/spv`,
			params,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	fetchSpv(id) {
		return axios({
			url: `${baseUrl}/spv/${id}`,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	requestSpv({ request, id }) {
		return axios({
			url: `${baseUrl}/spv/request-spv`,
			method: "POST",
			data: request,
			headers: this.getHeader(),
		});
	},
	cancelSpvRequest(id) {
		return axios({
			url: `${baseUrl}/spv/${id}/cancel`,
			method: "PATCH",
			headers: this.getHeader(),
		});
	},
	deleteSpv(id) {
		return axios({
			url: `${baseUrl}/spv/${id}`,
			method: "DELETE",
			headers: this.getHeader(),
		});
	},
	updateSpvRequest({ id, spv }) {
		return axios({
			url: `${baseUrl}/spv/${id}/business-info`,
			method: "PATCH",
			data: spv,
			headers: this.getHeader(),
		});
	},
	fetchSpvRequest(id) {
		return axios({
			url: `${baseUrl}/spv/${id}`,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	updateSpvCompliance({ id, payload }) {
		return axios({
			url: `${baseUrl}/spv/${id}/compliance`,
			method: "PATCH",
			data: payload,
			headers: this.getHeader(),
		});
	},
	updateSpv({ request, id }) {
		return axios({
			url: `${baseUrl}/spv/${id}`,
			method: "PATCH",
			data: request,
			headers: this.getHeader(),
		});
	},

	uploadSpv(spv) {
		return axios({
			url: `${baseUrl}/spv/upload-spv`,
			method: "POST",
			data: spv,
			headers: this.getHeader(),
		});
	},
	transferToken(obj) {
		return axios({
			url: `${baseUrl}/token/transfer`,
			method: "POST",
			data: obj,
			headers: this.getHeader(),
		});
	},
	createWithdrawalRequest(data) {
		return axios.post(`${baseUrl}/withdrawal-requests`, data, {
			headers: this.getHeader(),
		});
	},

	withdrawToTradeWallet(data) {
		return axios.post(`${baseUrl}/wallet/convert-cash`, data, {
			headers: this.getHeader(),
		});
	},

	withdrawFees() {
		return axios.get(`${baseUrl}/withdrawal-requests/fees`, {
			headers: this.getHeader(),
		});
	},

	getEntityCard() {
		return axios.get(`${baseUrl}/cards`, {
			headers: this.getHeader(),
		});
	},

	getInvestmentCategories() {
		return axios.get(`${baseUrl}/investment-categories`, {
			headers: this.getHeader(),
		});
	},

	generateVirtualAccount(payload) {
		return axios.post(`${baseUrl}/virtual-bank-accounts`, payload, {
			headers: this.getHeader(),
		});
	},

	fundWithProvider(data) {
		return axios.post(`${baseUrl}/payments/fund/${data.type}`, data.data, {
			headers: this.getHeader(),
		});
	},

	getVirtualAccount(payload) {
		return axios.get(`${baseUrl}/organisations/virtual-bank-accounts`, {
			params: {
				currency: payload,
			},
			headers: this.getHeader(),
		});
	},

	getVirtualAccountFee() {
		return axios.get(`${baseUrl}/virtual-accounts/fee`, {
			headers: this.getHeader(),
		});
	},

	/**
	 * The investor's own holdings, paginated.
	 *
	 * tokenModule's getUserTokens/getUnlimitedUserTokens have always called this, but the
	 * method itself was never copied across from investor-app — so both actions threw
	 * "getInvestorTokens is not a function" the moment anything invoked them.
	 *
	 * Same endpoint as getTokens(query) below; kept as a separate method so the existing
	 * callers of getTokens (which also serves /organisation/token) are untouched.
	 */
	// Deal rooms this account belongs to. Called by tokenModule/getUserDealRooms, which the
	// deal page dispatches on load.
	fetchUserDealRooms() {
		return axios.get(`${baseUrl}/user/organisations`, {
			headers: this.getHeader(),
		});
	},

	// Whether this account has paid the deal room's subscription fee. Gates the invest CTA.
	getDealRoomSubscriptionStatus(id) {
		return axios.get(`${organisationUrl}/${id}/subscription-fee-status`, {
			headers: this.getHeader(),
		});
	},

	getSubscriptionPlans(id) {
		return axios.get(`${organisationUrl}/${id}/subscription-fees`, {
			headers: this.getHeader(),
		});
	},

	getUserPrivateTokens() {
		return axios.get(`${baseUrl}/user/private-tokens`, {
			headers: this.getHeader(),
		});
	},

	getInvestorTokens(query) {
		return axios.get(`${userUrl}/tokens-paginated`, {
			params: {
				page: query && query.page,
				limit: query && query.limit,
			},
			headers: this.getHeader(),
		});
	},

	getTokens(query) {
		let url = "";
		query
			? (url = `${baseUrl}/user/tokens-paginated`)
			: (url = `${baseUrl}/organisation/token`);

		return axios.get(url, {
			params: query ? query : null,
			headers: this.getHeader(),
		});
	},

	getCompaniesRaising(query) {
		return axios.get(`${tokenUrl}/raising`, {
			params: {
				page: query.page,
				limit: query.limit,
			},
			headers: this.getHeader(),
		});
	},

	getCompaniesRaised(query) {
		return axios.get(`${tokenUrl}/raised`, {
			params: {
				page: query.page,
				limit: query.limit,
			},
			headers: this.getHeader(),
		});
	},

	getSingleToken(id) {
		return axios({
			url: `${baseUrl}/token/${id}`,
			headers: this.getHeader(),
		});
	},

	getTokenBalance(tokenSymbol) {
		return axios.get(`${baseUrl}/token/${tokenSymbol}/balance`, {
			headers: this.getHeader(),
		});
	},

	// Daily candles from the nightly price job, oldest first: [{ date, open, high, low, close }].
	getTokenOhlvc(id, params = {}) {
		return axios.get(`${baseUrl}/token/${id}/ohlvc`, {
			headers: this.getHeader(),
			params,
		});
	},

	// What investors paid the issuer per day of a raise at a set price, with a running total.
	getTokenRaiseHistory(id) {
		return axios.get(`${baseUrl}/token/${id}/raise-history`, {
			headers: this.getHeader(),
		});
	},

	// Any signed-in caller; 404 when the token has no NGX listing.
	getNgxToken(id) {
		return axios.get(`${baseUrl}/ngx/tokens/${id}`, {
			headers: this.getHeader(),
		});
	},

	// Any signed-in caller; 404 when the token is not a commodity deal.
	getCommodityToken(id) {
		return axios.get(`${baseUrl}/commodities/tokens/${id}`, {
			headers: this.getHeader(),
		});
	},

	// How much of what was sold is held: metal in the vault, or shares bought on the NGX.
	getCommodityBacking(id) {
		return axios.get(`${baseUrl}/commodities/tokens/${id}/backing`, {
			headers: this.getHeader(),
		});
	},

	getNgxBacking(id) {
		return axios.get(`${baseUrl}/ngx/tokens/${id}/backing`, {
			headers: this.getHeader(),
		});
	},

	// What the listed company has filed with the NGX, newest first; query: { category, page, limit }.
	// 404 when the token has no NGX listing.
	getNgxFilings(id, query = {}) {
		return axios.get(`${baseUrl}/ngx/tokens/${id}/filings`, {
			headers: this.getHeader(),
			params: query,
		});
	},

	getCompanyUpdate(query) {
		return axios.get(`${baseUrl}/organisation-update/${query.id}`, {
			// params: {
			// 	page: query.page,
			// 	limit: query.limit,
			// },
			headers: this.getHeader(),
		});
	},

	// One deal's updates (what investor-app shows), not the whole organisation's.
	getTokenUpdates(query) {
		return axios.get(`${baseUrl}/token/${query.id}/updates`, {
			headers: this.getHeader(),
		});
	},

	/**
	 * Place a bid into a book. Distinct from tradeToken: nothing settles here, the funds are
	 * held and the units are decided at allotment.
	 *
	 * bid_price and bid_rate are mutually exclusive server-side (Joi `nand`), and a strike bid
	 * sends neither — so the keys are OMITTED rather than sent as null.
	 *
	 * The backend reads the bidder off the JWT and records investor_model from its entity_type,
	 * so an organisation bidding its treasury needs nothing extra in the body. The route is
	 * gated on KYC (identityDocument) and the `invest:trade` permission.
	 */
	submitCommitment({ id, amount, bidPrice, bidRate, isStrikeBid, tranche }) {
		return axios.post(
			`${baseUrl}/token/${id}/commit`,
			{
				amount,
				// Required on a combined offering and refused on every other type, so it is sent only
				// when the caller has one rather than defaulted to an empty string.
				...(tranche ? { tranche } : {}),
				...(isStrikeBid ? { is_strike_bid: true } : {}),
				...(!isStrikeBid && bidPrice !== undefined && bidPrice !== null
					? { bid_price: bidPrice }
					: {}),
				...(!isStrikeBid && bidRate !== undefined && bidRate !== null
					? { bid_rate: bidRate }
					: {}),
			},
			{
				headers: this.getHeader(),
			}
		);
	},

	amendCommitment({ commitmentId, amount, bidPrice, bidRate, isStrikeBid }) {
		return axios.patch(
			`${baseUrl}/commitment/${commitmentId}`,
			{
				...(amount !== undefined && amount !== null ? { amount } : {}),
				...(isStrikeBid ? { is_strike_bid: true } : {}),
				...(!isStrikeBid && bidPrice !== undefined && bidPrice !== null
					? { bid_price: bidPrice }
					: {}),
				...(!isStrikeBid && bidRate !== undefined && bidRate !== null
					? { bid_rate: bidRate }
					: {}),
			},
			{
				headers: this.getHeader(),
			}
		);
	},

	withdrawCommitment(commitmentId) {
		return axios.delete(`${baseUrl}/commitment/${commitmentId}`, {
			headers: this.getHeader(),
		});
	},

	getCommitments(params) {
		return axios.get(`${baseUrl}/commitments`, {
			headers: this.getHeader(),
			params,
		});
	},

	/**
	 * Aggregate demand for an offering: summary, cover and the cumulative ladder. No individual
	 * bids and no bidder identities — the route is public for that reason.
	 *
	 * Each tranche of a combined offering is its own book, so `tranche` selects one.
	 */
	getExchangeListings(query) {
		return axios.get(`${baseUrl}/tokens/raised`, {
			params: {
				page: (query && query.page) || 1,
				limit: (query && query.limit) || 100,
			},
			headers: this.getHeader(),
		});
	},

	// The exchange page's four headline figures, counted on the server.
	getExchangeStats(query) {
		return axios.get(`${transactionUrl}/market-stats`, {
			params: { currency: query && query.currency },
			headers: this.getHeader(),
		});
	},

	getMarketActivity(query) {
		return axios.get(`${transactionUrl}/market-activity`, {
			params: {
				limit: (query && query.limit) || 20,
				currency: query && query.currency,
			},
			headers: this.getHeader(),
		});
	},

	getPortfolioPerformance(query) {
		return axios.get(`${baseUrl}/portfolio/performance`, {
			params: {
				range: query && query.range,
				interval: query && query.interval,
				currency: query && query.currency,
			},
			headers: this.getHeader(),
		});
	},

	getOfferingBook(id, params) {
		return axios.get(`${baseUrl}/token/${id}/book`, {
			headers: this.getHeader(),
			params,
		});
	},

	/**
	 * Every bucket on the wallet, not just the spendable one — including offer_hold, the money
	 * locked by live bids.
	 *
	 * Separate from getWalletBalance because /token/currency-balance returns a bare number per
	 * gToken and has no room for the buckets. Served on the org principal, so this is the
	 * company's own treasury.
	 */
	getCurrencyWallets() {
		return axios.get(`${baseUrl}/token/currency-wallets`, {
			headers: this.getHeader(),
		});
	},

	tradeToken({ id, amount, type, price }) {
		return axios.post(
			`${baseUrl}/token/${id}/${type}`,
			{
				amount,
				price,
			},
			{
				headers: this.getHeader(),
			}
		);
	},
	getMinimumWithdrawal() {
		return axios.get(`${baseUrl}/payments/minimum-withdrawal`, {
			headers: this.getHeader(),
		});
	},

	getDealRoomMembers(query) {
		return axios.get(`${organisationUrl}/members`, {
			params: {
				page: query.page,
				limit: query.limit,
				status: query.status,
			},
			headers: this.getHeader(),
		});
	},
	getDealRoomWaitlist() {
		return axios.get(`${organisationUrl}/waitlist`, {
			headers: this.getHeader(),
		});
	},

	getWaitlistMembers(query) {
		return axios.get(`${baseUrl}/invite-link/pending`, {
			params: {
				page: query.page,
				limit: query.limit,
			},
			headers: this.getHeader(),
		});
	},

	generateInviteLink(data) {
		return axios.post(`${baseUrl}/invite-link`, data, {
			headers: this.getHeader(),
		});
	},

	viewInviteLink() {
		return axios.get(`${baseUrl}/invite-link`, {
			headers: this.getHeader(),
		});
	},

	deactivateInviteLink(id) {
		return axios.delete(`${baseUrl}/invite-link/${id}`, {
			headers: this.getHeader(),
		});
	},

	addBankAccount(bank) {
		return axios({
			url: `${baseUrl}/bank`,
			method: "POST",
			data: bank,
			headers: this.getHeader(),
		});
	},
	deleteOrgFounder(founderId) {
		return axios({
			url: `${baseUrl}/founders/${founderId}`,
			method: "DELETE",
			headers: this.getHeader(),
		});
	},
	getDealByName(name) {
		return axios({
			url: `${orgsApiUrl}/token-requests/search?name=${name}`,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	getDealByStatus(params) {
		return axios({
			url: `${orgsApiUrl}/token-requests/search`,
			params,
			method: "GET",
			headers: this.getHeader(),
		});
	},
	getLastRaiseStage() {
		return axios({
			url: `${organisationUrl}/token/last-raise-stage`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	deleteDocument(payload) {
		return axios.post(
			`${baseUrl}/documents/delete/${payload.docId}`,
			{ type: payload.type },
			{
				headers: this.getHeader(),
			}
		);
	},

	getCarousel() {
		return axios.get(`${baseUrl}/carousels`, { headers: this.getHeader() });
	},

	updateSecondaryModal(payload) {
		return axios.post(`${organisationUrl}/skip-tour`, payload, {
			headers: this.getHeader(),
		});
	},

	verifyTokenSymbol(symbol) {
		return axios.get(`${baseUrl}//token/search?symbol=${symbol}`, {
			headers: this.getHeader(),
		});
	},

	uploadMultipleDoc(payload) {
		return axios.post(`${baseUrl}/documents`, payload.documents, {
			params: payload.params,
			headers: this.getHeader(),
		});
	},
	updateMultipleDoc(payload) {
		return axios.patch(`${baseUrl}/documents`, payload.documents, {
			params: payload.params,
			headers: this.getHeader(),
		});
	},
	convertWallet(payload) {
		return axios({
			url: `${baseUrl}/wallet/convert-wallet`,
			data: payload,
			method: "POST",
			headers: this.getHeader(),
		});
	},
	convertCurrency(params) {
		return axios({
			url: `${baseUrl}/payments/fx-amount`,
			params,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	getMinimumFunding() {
		return axios({
			url: `${baseUrl}/payments/minimum-deposit`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	createLoanConfiguration(payload) {
		return axios({
			url: `${baseUrl}/credit/loan-configuration`,
			method: "POST",
			headers: this.getHeader(),
			data: payload,
		});
	},

	getCreditorLoans(query) {
		return axios({
			url: `${baseUrl}/creditor/credit/loans`,
			method: "GET",
			headers: this.getHeader(),
			params: {
				page: query.page,
				limit: query.limit,
				currency: query.currency,
			},
		});
	},

	getBorrowers(query = {}) {
		return axios({
			url: `${baseUrl}/creditor/borrowers`,
			method: "GET",
			headers: this.getHeader(),
			params: {
				page: query.page,
				limit: query.limit,
				currency: query.currency,
			},
		});
	},

	getCreditorLoanSummary(currency) {
		const params = currency ? `?currency=${currency}` : '';
		return axios({
			url: `${baseUrl}/creditor/credit/summary${params}`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	getLoanConfiguration() {
		return axios({
			url: `${baseUrl}/credit/loan-configuration`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	updateLoanConfiguration(payload) {
		return axios({
			url: `${baseUrl}/credit/loan-configuration`,
			method: "PUT",
			headers: this.getHeader(),
			data: payload
		});
	},

	getCompaniesRaising(query) {
		return axios.get(`${baseUrl}/tokens/raising`, {
			params: {
				page: query.page,
				limit: query.limit,
			},
			headers: this.getHeader(),
		});
	},

	getCompaniesRaised(query) {
		return axios.get(`${baseUrl}/tokens/raised`, {
			params: {
				page: query.page,
				limit: query.limit,
			},
			headers: this.getHeader(),
		});
	},

	getPublicTokens() {
		return axios.get(`${baseUrl}/token/public`, {
			headers: this.getHeader(),
		});
	},
	getToken(id) {
		return axios.get(`${baseUrl}/token/${id}`, {
			headers: this.getHeader(),
		});
	},
	getTokenBalance(symbol) {
		return axios.get(`${baseUrl}/token/${symbol}/balance`, {
			headers: this.getHeader(),
		});
	},
	getAssetInfo(id) {
		return axios.get(`${baseUrl}/asset/${id}`, {
			headers: this.getHeader(),
		});
	},
	getWhyWeListed(tokenId) {
		return axios.get(`${baseUrl}/token/listing-reason/${tokenId}`, {
			headers: this.getHeader(),
		});
	},

	// 2fa
	generateQrCode(type) {
		return axios.get(`${baseUrl}/2fa/generate-qr-code`, {
			params: { type },
			headers: this.getHeader(),
		});
	},

	updateTwoFa(payload) {
		return axios.post(
			`${baseUrl}/2fa/${payload.type}`,
			{ token: payload.token },
			{
				headers: this.getHeader(),
			}
		);
	},

	validate2FaToken(payload) {
		return axios.post(
			`${baseUrl}/2fa/validate-token`,
			{ token: payload.token },
			{
				headers: this.getHeader(),
			}
		);
	},

	getIAMGroups() {
		return axios({
			url: `${baseUrl}/iam-group`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	getTeamMembers(query) {

		let params = {};
		if (query.status === "") {
			params = {
				page: query.page,
				limit: query.limit,
			};
		} else {
			params = {
				page: query.page,
				limit: query.limit,
				status: query.status,
			};
		}

		return axios({
			url: `${baseUrl}/team/members`,
			method: "GET",
			params,
			headers: this.getHeader(),
		});
	},

	getTeamMember(id) {
		return axios({
			url: `${baseUrl}/team/group/${id}/member`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	deleteTeamMember(payload) {
		return axios({
			url: `${baseUrl}/team/group/${payload.roleId}/member`,
			method: "DELETE",
			data: {
				memberId: payload.memberId
			},
			headers: this.getHeader(),
		});
	},

	createIAMGroup(payload) {
		return axios({
			url: `${baseUrl}/iam-group`,
			method: "POST",
			data: payload,
			headers: this.getHeader(),
		});
	},

	getTeamMember(id) {
		return axios({
			url: `${baseUrl}/team/group/${id}/member`,
			method: "GET",
			headers: this.getHeader(),
		});
	},

	deleteTeamMember(payload) {
		return axios({
			url: `${baseUrl}/team/group/${payload.roleId}/member`,
			method: "DELETE",
			data: {
				memberId: payload.memberId
			},
			headers: this.getHeader(),
		});
	},

	editRole(payload) {
		return axios({
			url: `${baseUrl}/iam-group/${payload.id}`,
			method: "PUT",
			data: payload.payload,
			headers: this.getHeader(),
		});
	},

	deleteRole(roleId) {
		return axios({
			url: `${baseUrl}/iam-group/${roleId}`,
			method: "DELETE",
			headers: this.getHeader(),
		});
	},

	deleteMember(memberId) {
		return axios({
			url: `${baseUrl}/team/members/${memberId}`,
			method: "DELETE",
			headers: this.getHeader(),
		});
	},

	addMemberToTeam({ payload, id }) {
		return axios({
			url: `${baseUrl}/admin/organisations/team-member/invite`,
			method: "POST",
			data: payload,
			headers: this.getHeader(),
		});
	},

	addUserBvn(data) {
    return axios.post(`${baseUrl}/kyc/verify-bvn`, data, {
      headers: this.getHeader(),
    });
  },
};


